import React from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./components/ErrorBoundary";
import ThemeFonts from "./themes/decor/fonts";

const App = () => {
  return (
    <ErrorBoundary>
      <ThemeFonts />
      <Routes />
    </ErrorBoundary>
  );
};

export default App;
